import { render, staticRenderFns } from "./crud-list.component.vue?vue&type=template&id=20b3f344"
import script from "./crud-list.component.vue?vue&type=script&lang=ts"
export * from "./crud-list.component.vue?vue&type=script&lang=ts"
import style0 from "./crud-list.component.vue?vue&type=style&index=0&id=20b3f344&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports